<template>
  <div class="loading-box" v-show="visible">
    <div id="loading-main" class="loading-main">
      <p class="loading-text"><span class="loader-blinker">Loading...</span></p>
    </div>
    <div class="modal-background"></div>
  </div>
</template>

<script>
export default {
  name: 'loading',
  // ===========================================================================
  // components
  // ===========================================================================
  components: {
  },
  // ===========================================================================
  // data
  // ===========================================================================
  data () {
    return {
    };
  },
  // ===========================================================================
  // computed
  // ===========================================================================
  computed: {
  },
  // ===========================================================================
  // props
  // ===========================================================================
  props: {
    visible: Boolean,
  },
  // ===========================================================================
  // created
  // ===========================================================================
  created () {
    this.$store.commit('loading/set_loading_cb', this.chgBackground);
  },
  // ===========================================================================
  // mounted
  // ===========================================================================
  mounted () {
  },
  // ===========================================================================
  // destroyed
  // ===========================================================================
  destroyed () {
  },
  // ===========================================================================
  // methods
  // ===========================================================================
  methods: {
    close () {
      this.$emit('close');
    },
    chgBackground () {
      if (this.$store.getters['loading/show_loading'] === true) {
        const tag = this.$lib._$id('loading-main');
        tag.style.display = 'flex';
      }
    },
  },
  // ===========================================================================
  // watch
  // ===========================================================================
  watch: {
  },
};
</script>

<style lang="scss">
.loading-box {
  .loading-main {
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    z-index: 2000;
    position: fixed;
    display: flex;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-pack: center;
    justify-content: center;
    background-color: rgba(55, 55, 55, 0.5);
  }

  .modal-background {
    position: fixed;
    z-index: 1000;
    background-color: rgba(255, 255, 255, 0);
  }

  .loading-text {
    width: 100%;
    text-align: center;
    background: #40c3f7;
    padding: 10px 0;
    color: #fefefe;
    font-size: 18px;
  }
  .loader-blinker {
    -webkit-animation:loader-blink 1.0s ease-in-out infinite alternate;
    -moz-animation:loader-blink 1.0s ease-in-out infinite alternate;
    animation:loader-blink 0.5s ease-in-out infinite alternate;
  }
  @-webkit-keyframes loader-blink {
    0% {opacity:0.3;}
    100% {opacity:1;}
  }
  @-moz-keyframes loader-blink {
    0% {opacity:0.3;}
    100% {opacity:1;}
  }
  @keyframes loader-blink {
    0% {opacity:0.3;}
    100% {opacity:1;}
  }

}
</style>
